const pcksData = (pkg: any, price: string) => ({
  packageId: pkg?.id,
  queryparam: pkg?.queryparam,
  packageName: pkg?.displayLabel,
  price,
  channels: `${pkg?.channel?.displayCount}+ ch.`,
  type: pkg?.type,
  subType: pkg?.subType
});

export const getComparePkgTrayData = ({ comparePkgTray, packageConfig, genreSvodOffers, getOffersData }) => {
  const genrePacks = [];
  const signaturePacks = [];
  const multiGenrePacks = [];

  packageConfig?.forEach((pkg: any) => {
    if (pkg?.type === 'genre') {
      const genrePkgPrice = genreSvodOffers?.offerPrices?.find(
        (offerPrice: any) => offerPrice?.[pkg?.id]
      )?.[pkg?.id] ?? null;
      const genrePrice = genrePkgPrice ? `$${genrePkgPrice?.price}` : '';

      if (pkg?.type === "genre" && !pkg?.subType) {
        genrePacks.push(pcksData(pkg, genrePrice));
      }
      if (pkg?.subType === "multi") {
        multiGenrePacks.push(pcksData(pkg, genrePrice));
      }
    }

    if (pkg?.type === 'internet') {
      const offerpPkgName = pkg?.id?.replace('ATT_TV_', '')?.replace('_', ' ')?.toUpperCase();
      const pkgPrice = getOffersData?.offerPrices?.find(
        (offerPrice: any) => offerPrice?.[offerpPkgName]
      )?.[offerpPkgName];
      signaturePacks.push(pcksData(pkg, pkgPrice ? `$${pkgPrice}` : ''));
    }
  });

  const getChipData = (displayPkgType: string) => {
    switch (displayPkgType) {
      case "genre": return genrePacks;
      case "multi": return multiGenrePacks;
      default: return signaturePacks;
    }
  };

  const buildSubHeading = (subHeading: any) => (subHeading ?
    {
      ...subHeading,
      chips: [...getChipData(subHeading?.displayPkgType)]
    } :
    undefined);

  const data = {
    ...comparePkgTray,
    subHeading1: comparePkgTray?.subHeading1 ? buildSubHeading(comparePkgTray.subHeading1) : undefined,
    subHeading2: comparePkgTray?.subHeading2 ? buildSubHeading(comparePkgTray.subHeading2) : undefined,
    subHeading3: comparePkgTray?.subHeading3 ? buildSubHeading(comparePkgTray.subHeading3) : undefined
  };

  return data;
};

export default getComparePkgTrayData;
